export default {
  title: 'Pobierz aplikację {{app}}',
  qr_code_desc: 'Zeskanuj ten kod QR telefonem, aby pobrać aplikację',
  cta: 'Pobierz aplikację i zaloguj się, aby otrzymać {{amount}} cashback!',
  download_from: 'Lub pobierz z:',
  direct_link: 'Bezpośredni link:',
};
